import Definition, { DefinitionList } from "@/models/definition";
import DefinitionValue from "@/models/definitionValue";
import { Meta } from "@/models/general";
import api from "@/plugins/axios";

const DefinitionsAPI = {
  async new(payload: Definition): Promise<Definition | undefined> {
    return api.post("/definitions", payload);
  },
  async update(payload: Definition): Promise<Definition | undefined> {
    return api.put(`/definitions/${payload.id}`, payload);
  },
  async get(id: string): Promise<Definition> {
    return api.get(`/definitions/${id}`);
  },
  async list(
    page = 1,
    pageSize = 10
  ): Promise<{ data: DefinitionList[]; meta: Meta }> {
    return api.get("/definitions", {
      params: { page: { number: page, size: pageSize } },
    });
  },
  async delete(id: string): Promise<void> {
    return api.delete(`/definitions/${id}`);
  },
  values: {
    async list(
      definitionId: string
    ): Promise<{ data: DefinitionValue[]; meta: Meta }> {
      return api.get(`/definitions/${definitionId}/definition_values`);
    },
    async new(
      definitionId: string,
      model: DefinitionValue
    ): Promise<DefinitionValue[]> {
      return api.post(`/definitions/${definitionId}/definition_values`, model);
    },
    async update(
      definitionId: string,
      model: DefinitionValue
    ): Promise<DefinitionValue[]> {
      return api.put(
        `/definitions/${definitionId}/definition_values/${model.id}`,
        model
      );
    },
    async delete(
      definitionId: string,
      model: DefinitionValue
    ): Promise<DefinitionValue[]> {
      return api.delete(
        `/definitions/${definitionId}/definition_values/${model.id}`
      );
    },
  },
};

export default DefinitionsAPI;
